import PropTypes from 'prop-types';

function ConditionalComponent(props) {
    if (!props.if) {
        return null;
    }
    return props.children;
}

ConditionalComponent.propTypes = {
    if: PropTypes.bool // always pops a warning if marked as required
}

export default ConditionalComponent;

